var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Classes.AbstractManager = new Class({
    Implements: [Options, Events, new Class(OCS.Viewer.Interfaces.AbstractManager)],
    initialize: function (op) {
        this.init(op);
    },
    init: function (op) {

    },
}); // End OCS.Viewer.Classes.AbstractManager
OCS.Viewer.Classes.SingletonManager = new Class({
    Extends: OCS.Viewer.Classes.AbstractManager,
    class_name: "SingletonManager",
    initialize: function (op) {
        if (OCS.Viewer.Live[this.manager_name]) {
            return OCS.Viewer.Live[this.manager_name];
        }
        this.parent(op);
        OCS.Viewer.Live[this.manager_name] = this;
    },
    destroy_manager: function () {
        OCS.Viewer.Live[this.manager_name] = null;
    }

}); // End OCS.Viewer.Classes.SingletonManager
